/* Almla redesign: Rebuy recommendations for the theme's own cart drawer,
   product page and homepage rows. Rebuy decides WHICH products to show
   (recommendations, top sellers); the products themselves are loaded from
   the storefront (/products/<handle>.js), so anything unpublished or sold out
   drops out and prices are in the shopper's currency. Every spot keeps its
   own non-Rebuy fallback, so a slow or failed request never empties it.

   Key: Rebuy's public storefront key (the one Rebuy's own rebuy.js serves),
   set in the header section and printed on #almCd as data-rebuy-key.

   Adds from Rebuy picks carry the hidden line properties Rebuy reports on:
   _source: Rebuy and _attribution: <placement> (AlmRebuy.props). */
window.AlmRebuy = (function () {
  var host = document.getElementById("almCd");
  var KEY = host && host.getAttribute("data-rebuy-key");
  if (!KEY) return null;
  var API = "https://rebuyengine.com/api/v1/";
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var TTL = 10 * 60 * 1000;
  var mem = {};

  function cached(k, load) {
    if (mem[k]) return mem[k];
    try {
      var s = JSON.parse(sessionStorage.getItem("almrb:" + k) || "null");
      if (s && Date.now() - s.t < TTL) return (mem[k] = Promise.resolve(s.v));
    } catch (e) {}
    return (mem[k] = load().then(function (v) {
      try { sessionStorage.setItem("almrb:" + k, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {}
      return v;
    }, function (e) { delete mem[k]; throw e; }));
  }

  // Ranked handles from a Rebuy endpoint, e.g. "products/recommended".
  function handles(endpoint, params) {
    var q = new URLSearchParams(params || {});
    q.set("key", KEY);
    var url = API + endpoint + "?" + q.toString();
    return cached(url, function () {
      return fetch(url).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (d) {
        return (d.data || []).map(function (p) { return p.handle; }).filter(Boolean);
      });
    });
  }

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "";
  function money(c) {
    var v = (c || 0) / 100;
    return "$" + v.toLocaleString("en-US", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  // Live storefront data in the card shape the theme uses (see alm-cart.js).
  function product(h) {
    return cached("p2:" + currency + ":" + h, function () {
      return fetch(ROOT + "products/" + encodeURIComponent(h) + ".js").then(function (r) {
        if (!r.ok) return null;
        return r.json().then(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          var img = p.featured_image || (p.images && p.images[0]) || "";
          if (img && img.indexOf("//") === 0) img = "https:" + img;
          // ns: not a sock (gift card, hat, tote), for spots that show socks only.
          var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
          var ns = !!p.gift_card || /^(hat|gift card)$/i.test(p.type || "") || ["hat", "hat bundle", "tote bag", "mini tote"].some(function (t) { return tags.indexOf(t) > -1; });
          return { h: p.handle, v: v.id, t: p.title, p: v.price, f: money(v.price), i: img ? img + (img.indexOf("?") > -1 ? "&" : "?") + "width=600" : "", u: p.url || "/products/" + p.handle, s: !p.available, ns: ns };
        });
      }).catch(function () { return null; });
    });
  }

  /* Up to opts.limit in-stock products for a Rebuy endpoint, in Rebuy's
     order, skipping opts.exclude handles (and non-socks with opts.socksOnly).
     opts.pool: how many of Rebuy's picks to load (default twice the limit). */
  function cards(endpoint, params, opts) {
    opts = opts || {};
    var limit = opts.limit || 8, skip = {};
    (opts.exclude || []).forEach(function (h) { skip[h] = 1; });
    return handles(endpoint, params).then(function (list) {
      list = list.filter(function (h) { return !skip[h]; }).slice(0, opts.pool || limit * 2);
      return Promise.all(list.map(product)).then(function (ps) {
        return ps.filter(function (p) { return p && !p.s && !(opts.socksOnly && p.ns); }).slice(0, limit);
      });
    });
  }

  function props(placement) { return { _source: "Rebuy", _attribution: "Almla " + placement }; }

  var api = { handles: handles, cards: cards, product: product, props: props };

  /* Lanes with "Order by Rebuy top sellers" (sections/alm-product-lane):
     the server renders twice the visible count; put the cards in Rebuy's
     order so its top sellers fill the visible places. Cards Rebuy doesn't
     rank keep their order after the ranked ones. */
  [].forEach.call(document.querySelectorAll("[data-rebuy-rank]"), function (lane) {
    handles("products/top_sellers", { limit: 60 }).then(function (rank) {
      var pos = {};
      rank.forEach(function (h, i) { pos[h] = i; });
      var cards = [].slice.call(lane.querySelectorAll(":scope > .cardwrap"));
      var keyed = cards.map(function (c, i) {
        var h = "";
        try { h = JSON.parse(c.getAttribute("data-alm")).h; } catch (e) {}
        return { c: c, r: h in pos ? pos[h] : 1e6 + i };
      });
      keyed.sort(function (a, b) { return a.r - b.r; });
      keyed.forEach(function (k) { lane.appendChild(k.c); });
      lane.scrollLeft = 0;
    }, function () {});
  });

  return api;
})();
